import {AdminPanel} from 'components/admin/admin';
import {Helmet} from 'react-helmet';

export const AdminPage = () => {
  return (
    <>
      <Helmet>
        <title>Admin - SPRiTEs-GPT</title>
      </Helmet>
      <AdminPanel />
    </>
  );
};
